import Countdown from "react-countdown";
import { Link, useNavigate } from "react-router-dom";
import Pill from "../atoms/Pill";
import css from "./OfferCard.module.scss";
import TableImage from "../atoms/TableImage";
import { Menu, Item, useContextMenu } from "react-contexify";
import "react-contexify/dist/ReactContexify.css";
import Switch from "../atoms/Switch";
import { deleteOffer, updateOffer } from "src/slices/offer";
import { useDispatch, useSelector } from "react-redux";
import { approveResource } from "src/slices/employee";
import { toast } from "react-toastify";
import Button from "../atoms/Button";
import { checkPermissions } from "src/slices/utils";

export default function OfferCard({ ...offer }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { permissions } = useSelector((state) => state.auth);
    const MENU_ID_OFFER = "offer-menu-id" + offer._id;

    const offerTimeRenderer = ({ formatted, completed, days }) => {
        if (completed) {
            return <Pill label="Archived" variant="secondary" iconLeft="fad fa-stopwatch" color="red" />;
        } else {
            return (
                <Pill
                    label={`${days > 0 ? `${days}d,` : ""} ${formatted.hours}:${formatted.minutes}:${
                        formatted.seconds
                    }`}
                    color="gray"
                    variant="secondary"
                    iconLeft="fad fa-stopwatch"
                />
            );
        }
    };

    const { show } = useContextMenu({
        id: MENU_ID_OFFER,
    });

    const handleApprove = () => {
        dispatch(
            approveResource({
                resource: "offer",
                data: { offers: JSON.stringify([offer.id]) },
            })
        );
    };

    // CHANGE ME
    function handleDelete() {
        const ConfirmActionModal = ({ closeToast, toastProps }) => (
            <div>
                Are you sure you want to delete this offer? This action cannot be undone.
                <div className={css.buttons}>
                    <Button
                        color="green"
                        action={() => dispatch(deleteOffer(offer.id))}
                        label={`Delete "${offer.name}"`}
                    ></Button>
                    <Button color="red" label={"Dismiss"}></Button>
                </div>
            </div>
        );
        toast(ConfirmActionModal, { autoClose: false });
    }

    function toggleHidden() {
        dispatch(
            updateOffer({
                id: offer._id,
                status: offer.status == "active" ? "hidden" : "active",
            })
        );
    }

    const handleClick = (e) => {
        navigate(`/offers/${offer.id}`);
    };
    return (
        <>
            <div className={`${css.card} ${offer.status === "hidden" ? css.hidden : undefined}`} onClick={handleClick}>
                <TableImage
                    iconUnicode=""
                    src={offer.photos[0]}
                    type="rect"
                    alt={offer.name}
                    boxStyles={{
                        borderRadius: "16px",
                    }}
                />
                <div className={css["details"]}>
                    <p className={css["name"]}>{offer.name}</p>
                    <p className={css["price"]}>${offer.price.toFixed(2)}</p>
                </div>
                <div
                    className={css["options-container"]}
                    onClick={(e) => {
                        // FIXME: Not working, clicking three dots still navigates
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                >
                    {checkPermissions(
                        permissions,
                        {
                            ...(offer.status == "pending" && {
                                update: ["pendingOffers"],
                                create: ["pendingOffers"],
                                approve: ["offers"],
                            }),
                            ...(offer.status != "pending" && {
                                update: ["offers"],
                                delete: ["offers"],
                            }),
                        },
                        true
                    ).hasPermission && <i className={`far fa-ellipsis-v ${css.options}`} onClick={show} />}
                </div>
                <div className={css.tags}>
                    <Countdown date={offer.endDate} renderer={offerTimeRenderer} />
                    {offer.status === "hidden" && (
                        <Pill label="hidden" color="orange" variant="secondary" iconLeft="fad fa-eye-slash" />
                    )}
                    <p className={css.sold}>Sold: {offer.initQty - offer.qty}/{offer.qty}</p>
                </div>
            </div>

            {checkPermissions(
                permissions,
                { update: ["offers", "pendingOffers"], delete: ["offers", "pendingOffers"] },
                true
            ).hasPermission && (
                <Menu id={MENU_ID_OFFER} className={css.menu}>
                    {offer.status !== "pending" ? (
                        <>
                            {checkPermissions(permissions, { update: ["offers"] }).hasPermission && (
                                <>
                                    <Item className={css.item}>
                                        <Link to={`/offers/${offer.id}`}>
                                            <span className={`${css["menu-option"]}`}>
                                                <i className="fad fa-pencil" />
                                                Edit
                                            </span>
                                        </Link>
                                    </Item>

                                    <Item className={css.item} onClick={toggleHidden}>
                                        <span className={css["menu-option"]}>
                                            <i
                                                className={`fad fa-${offer.status === "hidden" ? "eye" : "eye-slash"}`}
                                            />
                                            {offer.status === "hidden" ? "Unhide" : "Hide"}
                                        </span>
                                    </Item>
                                </>
                            )}

                            {checkPermissions(permissions, { delete: ["offers"] }).hasPermission && (
                                <Item onClick={handleDelete} className={`${css.item} ${css["item--del"]}`}>
                                    <span className={`${css["menu-option"]} ${css["option--del"]}`}>
                                        <i className="fad fa-trash" />
                                        Delete
                                    </span>
                                </Item>
                            )}
                        </>
                    ) : (
                        <>
                            {checkPermissions(permissions, { approve: ["offers"] }).hasPermission && (
                                <Item onClick={handleApprove} className={`${css.item} ${css["item--approve"]}`}>
                                    <span className={`${css["menu-option"]} ${css["option--approve"]}`}>
                                        <i className="fad fa-check" />
                                        Approve
                                    </span>
                                </Item>
                            )}

                            {checkPermissions(permissions, { update: ["pendingOffers"] }).hasPermission && (
                                <Item className={css.item}>
                                    <Link to={`/offers/${offer.id}`}>
                                        <span className={`${css["menu-option"]}`}>
                                            <i className="fad fa-pencil" />
                                            Edit
                                        </span>
                                    </Link>
                                </Item>
                            )}
                        </>
                    )}

                    {/* {
								<Item
									onClick={handleDelete}
									className={`${css.item} ${css['item--del']}`}>
									<span className={`${css['menu-option']} ${css['option--del']}`}>
										Reject
										<i className='fad fa-times' />
									</span>
								</Item>
							} */}
                </Menu>
            )}
        </>
    );
}
